module.exports = __webpack_public_path__ + "img/motor_no77.42642740.jpg";